/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CounselingDto } from '../../models/counseling-dto';
import { CreateCounselingDto } from '../../models/create-counseling-dto';

export interface CounselingControllerCreate$Params {
  centerChildId: string;
      body: CreateCounselingDto
}

export function counselingControllerCreate(http: HttpClient, rootUrl: string, params: CounselingControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CounselingDto>> {
  const rb = new RequestBuilder(rootUrl, counselingControllerCreate.PATH, 'post');
  if (params) {
    rb.query('centerChildId', params.centerChildId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CounselingDto>;
    })
  );
}

counselingControllerCreate.PATH = '/api/counseling';
